import React, { useEffect, useRef } from "react";
import { useMap } from "@vis.gl/react-google-maps";

type HeatBin = {
  lat: number;
  lng: number;
  count?: number;
};

type HeatMapCirclesProps = {
  data: HeatBin[];
};

const HeatMapCircles: React.FC<HeatMapCirclesProps> = ({ data }) => {
  const map = useMap() as google.maps.Map | null;
  const circlesRef = useRef<google.maps.Circle[]>([]);

  useEffect(() => {
    if (!map || !window.google) return;

    // Clean old
    circlesRef.current.forEach(c => c.setMap(null));
    circlesRef.current = [];

    const COLOR = "#1e88e5";

    // Increased radii for better visibility
    const RADIUS_OUTER = 42000; // 42 km
    const RADIUS_MID = 22000;   // 22 km
    const RADIUS_INNER = 9000;  // 9 km

    // Stronger opacities
    const OP_OUTER = 0.07;
    const OP_MID = 0.12;
    const OP_INNER = 0.18;

    data.forEach((p) => {
      const center = { lat: p.lat, lng: p.lng };

      const outer = new google.maps.Circle({
        center,
        radius: RADIUS_OUTER,
        fillColor: COLOR,
        fillOpacity: OP_OUTER,
        strokeWeight: 0,
        map,
      });

      const mid = new google.maps.Circle({
        center,
        radius: RADIUS_MID,
        fillColor: COLOR,
        fillOpacity: OP_MID,
        strokeWeight: 0,
        map,
      });

      const inner = new google.maps.Circle({
        center,
        radius: RADIUS_INNER,
        fillColor: COLOR,
        fillOpacity: OP_INNER,
        strokeWeight: 0,
        map,
      });

      circlesRef.current.push(outer, mid, inner);
    });

    return () => {
      circlesRef.current.forEach(c => c.setMap(null));
      circlesRef.current = [];
    };
  }, [map, data]);

  return null;
};

export default HeatMapCircles;